import WildAppResource from "./WildAppResource";
import LuStateAppResource from "./LuStateAppResource";
import OrderAppResource from './OrderAppResource';

class OrderPropertyAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'order-property';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'orders/properties';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'streetAddress',
            'city',
            'zip',
            'stateId',
            'orderUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            state: LuStateAppResource,
            order: OrderAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            state: 'state_id',
            order: 'order_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            streetAddress: {
                type: 'string',
                presence: true,
            },
            city: {
                type: 'string',
                presence: true,
            },
            zip: {
                type: 'string',
            },
            orderUuid: {
                type: 'string',
            },
            stateId: {
                presence: true,
            },
        };
    }

}

export default OrderPropertyAppResource;
